import React, { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";

import { Radio, Form, Input, message, Button, Select, Modal } from "antd";
import CandidateAddModal from "../../CandidateAddModal";

import useResumeStore from "../../../store/resume.store";
import useJDStore from "../../../store/jd.store";

import "./nujobsCandidateProfileForm.scss";

import editIcon from "../../../assets/pencil.png";
import StackChart from "../../StackChart";
import { EDUCATION_OPTIONS, SUPPORTED_LOCATION } from "../../../helper/categoryconstants";
import { reasonForLeavingFilter } from "../../../helper/filterconstants";
import { GetSourceOwner } from "../../../helper/commonFunctions";

export default function NujobsCandidateProfileForm({ jdID, resumeID }) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(
    "Are you sure you want to save your changes?"
  );
  const [submittedValues, setSubmittedValues] = useState(null);
  const [fillForm, setFillForm] = useState("Yes");
  const [currentView, setCurrentView] = useState("profile");
  const [isEditMode, setIsEditMode] = useState(false);
  const [haveOtherOffer, setOffersGot] = useState(false);
  const [notWorking, setNotWorking] = useState(false);
  const [formKey, setFormKey] = useState(1);

  const {
    selectedProfileResume,
    downloadResumeByID,
    updateProfileInApplication,
    selectedApplication,
    getSpecificApplicationByJD,
    getProfileResumeDetails,
    resetUpdateFlagSpecific,
    updateFlagSpecific
  } = useResumeStore();

  const { selectedJD } = useJDStore();

  var value = jdID;

  const [currentApplication, setCurrentApplication] = useState();
  const [currentCandidatestatus, setCurrentCandidateStatus] = useState(
    selectedApplication?.candidatestatus.status
  );

  useEffect(() => {
    setCurrentApplication(selectedApplication);
    setCurrentCandidateStatus(selectedApplication?.candidatestatus.status);
    if(selectedProfileResume?.employmentdetails.jobcontinuity == "Not Working"){
        setNotWorking(true)
    }else{
        setNotWorking(false)
    }
  }, [selectedApplication]);

  //dont render till the respose come
  if (selectedApplication === null || selectedProfileResume === null) return;

  const handleDownloadResume = (resumeID) => {
    downloadResumeByID(jdID, resumeID);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  function getRequirementType() {
    if (selectedJD?.JDProject?.ReqType == "customer_project") {
      if (selectedJD?.JDClient?.ClientJobType == "TP") {
        return true;
      }
    }
    return false;
  }

  function convertToUnixTimestamp(dateStr) {
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return Math.floor(date.getTime() / 1000);
  }

  const encodeApplicationJson = (values) => {
    let encodedJsonValues = {};
    //FSM to maintain the JD state
    encodedJsonValues.applicationstatus = "Processing";
    //get company details
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    encodedJsonValues.qhoid = userData.qhoid;
    encodedJsonValues.accounttype = userData.account_type;
    encodedJsonValues.qhrid = resumeID;
    encodedJsonValues.qhcompanyjid = jdID;
    encodedJsonValues.version = "1.0";
    encodedJsonValues._id = "Not Needed Only Dummy";
    encodedJsonValues.fillform = fillForm

    //now fill the parameters
    encodedJsonValues.applicationid = {};
    encodedJsonValues.applicationid.name = values.name;
    encodedJsonValues.applicationid.email = values.email;
    encodedJsonValues.applicationid.mobile = values.mobile;
    encodedJsonValues.applicationid.aadharid = values.aadharnumber;

    //ids in resumre
    encodedJsonValues.personaldetail = {};
    encodedJsonValues.personaldetail.name = values.name;
    encodedJsonValues.personaldetail.email = values.email;
    encodedJsonValues.personaldetail.mobile = values.mobile;
    encodedJsonValues.personaldetail.aadharid = values.aadharnumber;
    encodedJsonValues.personaldetail.dob = values.dob;
    encodedJsonValues.personaldetail.gender = values.gender;
    encodedJsonValues.personaldetail.uan = values.uannumber;    
    
    if(fillForm == "Yes"){
        encodedJsonValues.newemploymentdetails = {};
        encodedJsonValues.newemploymentdetails.preferredlocation = [];

        encodedJsonValues.newemploymentdetails.preferredlocation =
          values.preferredlocation;
        encodedJsonValues.newemploymentdetails.locationchangereason =
          values.locationchangereason;
        encodedJsonValues.newemploymentdetails.ectc = {};
        encodedJsonValues.newemploymentdetails.ectc.totalctc = parseFloat(
          values.ectc
        );
        encodedJsonValues.newemploymentdetails.ectc.ctcremarks = values.ctcremarks;
        encodedJsonValues.newemploymentdetails.payroll = values.payroll;
        encodedJsonValues.newemploymentdetails.relevantexp =
          parseFloat(values.relevantexperience);
        encodedJsonValues.newemploymentdetails.totalexp = parseFloat(values.totalexp);
        encodedJsonValues.newemploymentdetails.appliedbefore =
          values.candidatestatus == "Already Applied" ? "Yes" : "No";
        encodedJsonValues.newemploymentdetails.alreadygotcall =
          values.candidatestatus == "Already Got Call" ? "Yes" : "No";

        if (values.candidatestatus == "Interview before 6 months") {
          encodedJsonValues.newemploymentdetails.interviewgiven =
            "Interview before 6 months";
        } else if (values.candidatestatus == "Interview within 6 months") {
          encodedJsonValues.newemploymentdetails.interviewgiven =
            "Interview within 6 months";
        } else {
          encodedJsonValues.newemploymentdetails.interviewgiven = "No";
        }
        encodedJsonValues.newemploymentdetails.ectcoptions = values.ectcoptions;
        encodedJsonValues.newemploymentdetails.otherremarks = values.otherremarks;

        encodedJsonValues.newemploymentdetails.softskills = values.softskills;
        encodedJsonValues.newemploymentdetails.finaldoj = values.doj;
        encodedJsonValues.newemploymentdetails.octc = {};
        encodedJsonValues.newemploymentdetails.octc.totalctc = parseFloat(
          values.offeredctc
        );

        let newDate = getTimeNow();

        encodedJsonValues.sourcingdetails = {};
        encodedJsonValues.sourcingdetails.method = "By Team";
        encodedJsonValues.sourcingdetails.teamdetails = {};
        encodedJsonValues.sourcingdetails.teamdetails.qhuid = userData.qhuid;
        encodedJsonValues.sourcingdetails.teamdetails.name = userData.username;
        encodedJsonValues.sourcingdetails.teamdetails.updatedon = newDate;

        encodedJsonValues.candidatestatus = {};
        encodedJsonValues.candidatestatus.status = values.candidatestatus;
        encodedJsonValues.candidatestatus.updatedby = {};
        encodedJsonValues.candidatestatus.updatedby.updatedon = newDate;
        encodedJsonValues.candidatestatus.updatedby.qhuid = userData.qhuid;
        encodedJsonValues.candidatestatus.updatedby.name = userData.username;

        encodedJsonValues.interviewstatus = null;
        encodedJsonValues.selectionstatus = null;
        encodedJsonValues.skillsevalsatus = null;
        encodedJsonValues.testevalstatus = null;

        //now fill the parameters
        encodedJsonValues.skilltags = values.skilltags
        encodedJsonValues.employmentdetails = {};
        encodedJsonValues.employmentdetails.currentcompany = values.currentcompany;
        encodedJsonValues.employmentdetails.designation = values.designation;
        encodedJsonValues.employmentdetails.currentlocation =values.currentlocation;
        encodedJsonValues.employmentdetails.currentctc = {};
        encodedJsonValues.employmentdetails.currentctc.totalctc = parseFloat(
          values.currentctc
        );
        encodedJsonValues.employmentdetails.noticeperiod = {};
        encodedJsonValues.employmentdetails.noticeperiod.officialnp = parseInt(
          values.noticeperiod
        );
        encodedJsonValues.employmentdetails.noticeperiod.isnegotiable =
          values.isnegotiable;
        encodedJsonValues.employmentdetails.noticeperiod.negotiableto =
          parseInt(values.negotiablenoticeperiod);
        encodedJsonValues.employmentdetails.noticeperiod.lwd = values.lwd;
        if (values.lwd != "")
          encodedJsonValues.employmentdetails.noticeperiod.lwdts =
            convertToUnixTimestamp(values.lwd);

        encodedJsonValues.employmentdetails.noticeperiod.reason = values.reason;
        encodedJsonValues.employmentdetails.noticeperiod.reason = values.reason;
        encodedJsonValues.employmentdetails.jobcontinuity = values.jobcontinuity;
        if(encodedJsonValues.employmentdetails.jobcontinuity == "Not Working"){
              encodedJsonValues.employmentdetails.notworkingreason = values.notworkingreason;
        }else{
              encodedJsonValues.employmentdetails.notworkingreason ="NA"
        }
        encodedJsonValues.educationaldetail = {};
        encodedJsonValues.educationaldetail.maxdegree = values.maxdegree;
        encodedJsonValues.educationaldetail.stream = values.stream;
        encodedJsonValues.educationaldetail.college = values.college;
        encodedJsonValues.educationaldetail.percentage = values.percentage;
        encodedJsonValues.educationaldetail.passoutyear = values.passoutyear;

        encodedJsonValues.offerdetails = {};
        encodedJsonValues.offerdetails.otheroffer = values.otheroffer;
        encodedJsonValues.offerdetails.offerctc = values.offerctc;
        encodedJsonValues.offerdetails.offerlocations = values.offerlocations;
        encodedJsonValues.offerdetails.offerdoj = values.offerdoj;
        encodedJsonValues.offerdetails.offercompanytype = values.offercompanytype;
        encodedJsonValues.offerdetails.whyjoinus = values.whyjoinus;
    }

    return encodedJsonValues;
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const handleFormSubmit = (values) => {
    setSubmittedValues(values);
    setOpenConfirm(true);
  };

  const handleOffer = (e) => {
    if (e.target.value == "No Offer") {
      setOffersGot(false);
    } else if (e.target.value == "In Pipeline") {
      setOffersGot(true);
    } else {
      setOffersGot(true);
    }
  };

  const handleJobContinuity = (e) => {
    if (e.target.value == "Not Working") {
      setNotWorking(true);
    }else {
      setNotWorking(false);
    }
  };
  const handleFormSubmitError = (values) => {
    message.success("Something is wrong. No JDID");
    setCurrentView("assignment");
    setIsEditMode(false);
  };

  const appvalues = {
    fillform:fillForm,
    name: selectedProfileResume?.personaldetail.name,
    email: selectedProfileResume?.personaldetail.email,
    mobile: selectedProfileResume?.personaldetail.mobile,
    score: selectedApplication?.resumescore.score,
    skilltags: selectedProfileResume?.skilltags,
    payroll: selectedApplication?.newemploymentdetails.payroll,
    candidatestatus: selectedApplication?.candidatestatus.status,
    appliedbefore: selectedApplication?.newemploymentdetails.appliedbefore,
    interviewbefore: selectedApplication?.newemploymentdetails.interviewgiven,
    alreadygotcall: selectedApplication?.newemploymentdetails.alreadygotcall,
    currentlocation: selectedProfileResume?.employmentdetails.currentlocation,
    preferredlocation:
      selectedApplication?.newemploymentdetails.preferredlocation,
    locationchangereason:
      selectedApplication?.newemploymentdetails.locationchangereason,
    maxdegree: selectedProfileResume?.educationaldetail.maxdegree,
    stream: selectedProfileResume?.educationaldetail.stream,
    college: selectedProfileResume?.educationaldetail.college,
    percentage: selectedProfileResume?.educationaldetail.percentage,
    passoutyear: selectedProfileResume?.educationaldetail.passoutyear,
    designation: selectedProfileResume?.employmentdetails.designation,
    totalexp: selectedApplication?.newemploymentdetails.totalexp,
    relevantexperience: selectedApplication?.newemploymentdetails.relevantexp,
    currentcompany: selectedProfileResume?.employmentdetails.currentcompany,
    noticeperiod:
      selectedProfileResume?.employmentdetails.noticeperiod.officialnp === 1024
        ? ""
        : selectedProfileResume?.employmentdetails.noticeperiod.officialnp,
    negotiablenoticeperiod:
      selectedProfileResume?.employmentdetails.noticeperiod.negotiableto === 1024
        ? ""
        : selectedProfileResume?.employmentdetails.noticeperiod.negotiableto,
    lwd: selectedProfileResume?.employmentdetails.noticeperiod.lwd,
    reason: selectedProfileResume?.employmentdetails.noticeperiod.reason,
    jobcontinuity: selectedProfileResume?.employmentdetails.jobcontinuity,
    notworkingreason: selectedProfileResume?.employmentdetails.notworkingreason,
    currentctc: selectedProfileResume?.employmentdetails.currentctc.totalctc,
    ectc: selectedApplication?.newemploymentdetails.ectc?.totalctc,
    offeredctc: selectedApplication?.newemploymentdetails.octc?.totalctc,
    doj: selectedApplication?.newemploymentdetails.finaldoj,
    softskills: selectedApplication?.newemploymentdetails.softskills,
    ectcoptions: selectedApplication?.newemploymentdetails.ectcoptions,
    ctcremarks: selectedApplication?.newemploymentdetails.ctcremarks,
    otheroffer: selectedProfileResume?.offerdetails.otheroffer,
    offercompanytype: selectedProfileResume?.offerdetails.offercompanytype,
    offerctc: selectedProfileResume?.offerdetails.offerctc,
    offerlocations: selectedProfileResume?.offerdetails.offerlocations,
    offerdoj: selectedProfileResume?.offerdetails.offerdoj,
    whyjoinus: selectedProfileResume?.offerdetails.whyjoinus,
    aadharnumber: selectedProfileResume?.personaldetail.aadharid,
    uannumber: selectedProfileResume?.personaldetail.uan,
    otherremarks: selectedApplication?.newemploymentdetails.otherremarks,
    dob: selectedProfileResume?.personaldetail.dob,
    gender: selectedProfileResume?.personaldetail.gender,
    ownership:selectedApplication.sourcingdetails.method,
    addedby:GetSourceOwner(selectedApplication).sourceName,
    addedon:GetSourceOwner(selectedApplication).sourceDate,
    lastupdatedby:selectedApplication.candidatestatus.updatedby.name, 
    lastupdatedon:selectedApplication.candidatestatus.updatedby.updatedon, 
    applicationstatus:selectedApplication.applicationstatus,        
  };

  const handleOk = () => {
    const jasonValues = encodeApplicationJson(submittedValues);
    updateProfileInApplication({
      jasonValues,
      jdID,
      resumeID,
    });
    message.success("Updated Profile");
    setConfirmLoading(false);
    setOpenConfirm(false);
    setIsEditMode(false);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
  };

  return (
    <div className="nujobs-profile-summary-wrapper">
      <div style={{ textAlign: "center" }}>
        Candidate Profile - {appvalues.name}
      </div>
      <br></br>
      <div className="profile-stackChart-wrapper">
        <StackChart stackData={null} stack={false} showLegend />
      </div>
      <div className="profile-creation-form-wrapper">
        <div className="header">

          <h5 className="jd-creation-form-title">
            {" "}
            {resumeID}
          </h5>

          
          {!isEditMode ? (
            <Button
              className="profile-creation-edit-button"
              onClick={() => setIsEditMode(true)}
              type="primary"
            >
              <img src={editIcon} alt="Edit" width="14" height="14" />
            </Button>
          ) : (
            <Button
              className="profile-creation-edit-button"
              onClick={() => setIsEditMode(false)}
            >
              <CloseOutlined /> Cancel
            </Button>
          )}
        </div>
        {currentApplication == null ? (
          <></>
        ) : (
          <Form
            key={formKey}
            className="profile-creation-form"
            name="profile-creation-form"
            justify="start"
            layout="vertical"
            autoComplete="off"
            onFinish={value ? handleFormSubmit : handleFormSubmitError}
            initialValues={appvalues}
          >

            <div className="triple-input-wrapper">
              <Form.Item
                rules={[{ required: true, message: 'Name is required!' }]}
                className="jd-creation-field-item"
                label="Candidate Name"
                name="name"
              >
                <Input
                  disabled={!isEditMode}
                  className="jd-creation-input"
                />
              </Form.Item>

              <Form.Item
                required={value ? false : true}
                className="jd-creation-field-item"
                label="Email ID"
                name="email"
              >
                <Input
                  disabled={true}
                  required={value ? false : true}
                  className="jd-creation-input"
                />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'Number is required!' }]}
                name="mobile"
                className="jd-creation-field-item"
                label="Mobile Number"
              >
                <Input
                  disabled={!isEditMode}
                  className="jd-creation-input"
                />
              </Form.Item>
            </div>


                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Location is required!' }]}
                      name="currentlocation"
                      className="jd-creation-field-item"
                      label="Current Location"
                    >
                      <Input
                        disabled={!isEditMode}
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[
                          { required: true, message: 'Please select Location!' }
                      ]}
                      name="preferredlocation"
                      className="jd-creation-field-item"
                      label="Preferred Locations"
                    >
                      <Select
                        disabled={!isEditMode}
                        mode="multiple"
                        allowClear
                        className="jd-creation-input"
                        options={SUPPORTED_LOCATION}
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify reason!' }
                      ]}
                      name="locationchangereason"
                      className="jd-creation-field-item"
                      label="Relocation Reason"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please Select"
                        className="jd-creation-input"
                        options={[
                          { value: "NA", label: "NA" },
                          { value: "Partner Job", label: "Partner Job" },
                          {
                            value: "Family Member Lives there",
                            label: "Family Member Lives there",
                          },
                          { value: "Carrer Growth", label: "Carrer Growth" },
                          { value: "Other Reasons", label: "Other Reasons" },
                        ]}
                      />
                    </Form.Item>
                  </div>

                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Company name is required!' }]}
                      name="currentcompany"
                      className="jd-creation-field-item"
                      label="Current Company"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>                    
                    <Form.Item
                      rules={[{ required: true, message: 'Designation is required!' }]}
                      name="designation"
                      className="jd-creation-field-item"
                      label="Current Designation"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      rules={[{ required: true, message: 'Exp is required!' }]}
                      className="jd-creation-field-item"
                      label="Total Exp (Yrs)"
                      name="totalexp"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="number"
                        placeholder={"x.y"}
                        className="jd-creation-input"
                        name="totalexp"
                      />
                    </Form.Item>

                  </div>

                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'CTC is required!' }]}
                      name="currentctc"
                      className="jd-creation-field-item"
                      label="Current CTC (LPA)"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[{ required: true, message: 'ECTC is required!' }]}
                      name="ectc"
                      className="jd-creation-field-item"
                      label="ECTC (LPA)"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                      />
                    </Form.Item>
                  </div>

                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify!' }
                      ]}
                      className="jd-creation-field-item"
                      label="Official Notice Period (Days)"
                      name="noticeperiod"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-input"
                        options={[
                          { value: 0, label: 0 },
                          { value: 15, label: 15 },
                          { value: 30, label: 30 },
                          { value: 45, label: 45 },
                          { value: 60, label: 60 },
                          { value: 90, label: 90 },
                          { value: 120, label: 120 },
                          { value: 180, label: 180 },
                        ]}
                      />
                    </Form.Item>                    
                    <Form.Item
                      className="jd-creation-field-item"
                      label="LWD"
                      name="lwd"
                    >
                      <Input
                        disabled={!isEditMode}
                        type="text"
                        placeholder={"dd/mm/yyyy"}
                        className="jd-creation-input"
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[
                          { required: true, message: 'Please specify!' }
                      ]}     
                      className="jd-creation-field-item"
                      label="Reason for Leaving "
                      name="reason"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-input"
                        options={reasonForLeavingFilter}
                      />
                    </Form.Item>
                  </div>

                    <Form.Item
                      rules={[{ required: true, message: 'Pls select one option' }]}
                      name="jobcontinuity"
                      className="jd-creation-field-item"
                      label="Job Continuity"
                      onChange={handleJobContinuity}
                    >
                      <Radio.Group
                        disabled={!isEditMode}
                        className="jd-creation-radio-wrapper-3"
                      >
                        <Radio className="radio-option" value={"Currently Working"}>
                          Currently Working
                        </Radio>
                        <Radio className="radio-option" value={"Not Working"}>
                          Not Working
                        </Radio>
                        <Radio
                          className="radio-option"
                          value={"Freelancing"}
                        >
                          Freelancing
                        </Radio>
                      </Radio.Group>
                    </Form.Item>

                  <div className="dual-input-wrapper">
                    {notWorking ? (
                      <>
                        <Form.Item
                          rules={[
                              { required: true, message: 'Please specify!' }
                          ]}     
                          className="jd-creation-field-item"
                          label="Currently Not Working Due to"
                          name="notworkingreason"
                        >
                          <Select
                            disabled={!isEditMode}
                            placeholder="Please select"
                            className="jd-creation-input"
                            options={[
                              { value: "NA", label: "NA" },
                              {
                                value: "In Transition Gap",
                                label: "Gap before joining another company",
                              },
                              { value: "Persoanl Reasons", label: "Persoanl Reasons" },
                              {
                                value: "Was Taking Care of family",
                                label: "Was Taking Care of family",
                              },
                              {
                                value: "Personal Health Issues",
                                label: "Personal Health Issues",
                              },
                              { value: "Higher Education Break", label: "Higher Education Break" },
                              { value: "Competitive Exam Preperation Break", label: "Competitive Exam Preperation Break" },
                              { value: "Career Break", label: "Career Break" },
                              { value: "Maternity Break", label: "Maternity Break" },
                              { value: "Other reasons", label: "Other reasons" },
                            ]}
                          />
                        </Form.Item>                  
                      </>)
                      :<></>
                    }

                  </div>


                  <div className="triple-input-wrapper">
                    <Form.Item
                      rules={[{ required: true, message: 'Please select an option!' }]}
                      name="maxdegree"
                      className="jd-creation-field-item"
                      label="Max Degree"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-input"
                        options={EDUCATION_OPTIONS}
                      />
                    </Form.Item>
                    <Form.Item
                      name="passoutyear"
                      className="jd-creation-field-item"
                      label="Year of Passing"
                      rules={[{ required: true, message: 'Passout Year is requried' }]}
                    >
                      <Input
                        disabled={!isEditMode}
                        className="jd-creation-input"
                      />
                    </Form.Item>

                    <Form.Item
                      name="college"
                      className="jd-creation-field-item"
                      label="Uni/College"
                    >
                      <Select
                        disabled={!isEditMode}
                        placeholder="Please select"
                        className="jd-creation-input"
                        options={[
                          { value: "IIT", label: "IITs" },
                          { value: "IIM", label: "IIMs" },
                          { value: "REC", label: "RECs" },
                          { value: "JNTU", label: "JNTU" },
                          { value: "Govt College", label: "Govt College" },
                          { value: "Private College", label: "Private College" },
                          { value: "AIIMS", label: "AIIMS" },
                          { value: "Foreign", label: "Foreign" },
                          { value: "Others", label: "Others" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="triple-input-wrapper">
                    <Form.Item
                      name="stream"
                      className="jd-creation-field-item"
                      label="Stream"
                    >
                      <Input disabled={!isEditMode} className="jd-creation-input" />
                    </Form.Item>
                    <Form.Item
                      name="percentage"
                      className="jd-creation-field-item"
                      label="Percentage/CGPA of Max Degree"
                    >
                      <Input disabled={!isEditMode} className="jd-creation-input" />
                    </Form.Item>
                    <Form.Item
                      name="uannumber"
                      className="jd-creation-field-item"
                      label="UAN Number"
                    >
                      <Input disabled={!isEditMode} className="jd-creation-input" />
                    </Form.Item>
                  </div>
                  <div className="triple-input-wrapper">
                    <Form.Item
                      name="aadharnumber"
                      className="jd-creation-field-item"
                      label="Aadhar Number"
                    >
                      <Input disabled={!isEditMode} className="jd-creation-input" />
                    </Form.Item>
                    <Form.Item
                      name="dob"
                      className="jd-creation-field-item"
                      label="DoB"
                    >
                      <Input
                        disabled={!isEditMode}
                        className="jd-creation-input"
                        placeholder="dd/mm/yyyy"
                      />
                    </Form.Item>
                    <Form.Item
                      name="gender"
                      className="jd-creation-field-item"
                      label=" Gender"
                    >
                      <Radio.Group
                        disabled={!isEditMode}
                        className="jd-creation-radio-wrapper"
                      >
                        <Radio className="radio-option" value={"Male"}>
                          Male
                        </Radio>
                        <Radio className="radio-option" value={"Female"}>
                          Female
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

            <div className="triple-input-wrapper">
              <Form.Item
                className="jd-creation-field-item"
                label="Ownership"
                name="ownership"
              >
                <Input
                  disabled={true}
                  className="jd-creation-input"
                />
              </Form.Item>              
              <Form.Item
                className="jd-creation-field-item"
                label="Nujobs Username"
                name="addedby"
              >
                <Input
                  disabled={true}
                  className="jd-creation-input"
                />
              </Form.Item>
              <Form.Item
                className="jd-creation-field-item"
                label="Applied On"
                name="addedon"
              >
                <Input
                  disabled={true}
                  className="jd-creation-input"
                />
              </Form.Item>
            </div>              
            <div className="triple-input-wrapper">
              <Form.Item
                className="jd-creation-field-item"
                label="Last Updated By"
                name="lastupdatedby"
              >
                <Input
                  disabled={true}
                  className="jd-creation-input"
                />
              </Form.Item>

              <Form.Item
                className="jd-creation-field-item"
                label="Last Updated On"
                name="lastupdatedon"
              >
                <Input
                  disabled={true}
                  required={value ? false : true}
                  className="jd-creation-input"
                />
              </Form.Item>
              <Form.Item
                className="jd-creation-field-item"
                label="Application Status"
                name="applicationstatus"
              >
                <Input
                  disabled={true}
                  required={value ? false : true}
                  className="jd-creation-input"
                />
              </Form.Item>
              
            </div>

            <Button
              style={{ width: "100%", height: "40px", fontWeight: "600" }}
              type="primary"
              disabled={!isEditMode}
              htmlType="submit"
            >
              Save Candidate Details
            </Button>
          </Form>
        )}
      </div>

      <CandidateAddModal />

      <Modal
        title="Update Profile"
        centered
        open={openConfirm}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>
    </div>
  );
}
